/**
 * @file 常量定义，定义所有ajax接口的path
 * @author cuibolun<cuibolun@baijia.com>
 * @date 2021-03-04
 */

const ajaxConfig = {
    USER: {
        GET_USER_INFO: '/api/getuserinfo'
    },

    CMS: {
        GET_BY_CHANNEL_CODE: '/cms/getByChannelCode.json',
        GET_CATEGORY_LIST: '/cms/category/list.json',
        GET_INFO_BY_ID: '/cms/getInfoById.json',
        GET_LIST_BY_CHANNEL_CODE: '/cms/getListByChannelCode.json',
        GET_VIDEO_PLAY_URL: '/cms/video/getVideoPlayUrl.json',
        RECENT_NEWS: '/news/list.json',
        NEWS_INFO: '/news/info.json',
    },

    STOCK: {
        GET_STOCK_INFO: '/stock/baseInfo.json',
        GET_MIN_K_LINE: '/stock/minute/kLine.json',
        GET_PERIOD_K_LINE: '/stock/period/kLine.json',
    },

    SEC: {
        GET_SEC_LIST: '/sec/list.json',
        GET_SEC_INFO: '/sec/info.json',
        GET_PDF_INFO: '/sec/pdf.json',
        GET_SEC_DOWNLOAD_WORD: '/sec/download.json',
        GET_SEC_DOWNLOAD_EXCEL: '/sec/download/excel.json',
    },

    SUBSCRIBE: {
        CANCEL: '/customize/cancel.json',
        SUBSCRIBE: '/customize/save.json'
    }
};

export default ajaxConfig;
